module.exports = __webpack_public_path__ + "static/background-image-xs-f38cb70c12b27d67eefa5514b36c7dac.mp4";